<template>
  <tci-solution subtitle="" :title="$t('solution.mes.title')" :infos='$i18n.locale=="zh"?infos:infos_ja' :images = '$i18n.locale=="zh"?infos:infos_ja'></tci-solution>
</template>

<script>
import TciSolution from "@/components/TciSolution.vue";

export default {
  name: "CompanyService",
  components: {
    "tci-solution": TciSolution
  },
  data: () => ({
    infos: [
    {"imageUrl":require('../assets/solution/s1-0.jpg')},
    {"imageUrl":require('../assets/solution/s1-5.jpg'),"title":"MES是什么?"},
    {"imageUrl":require('../assets/solution/s1-1.jpg'),"title":"为什么需要MES"},
    {"imageUrl":require('../assets/solution/s1-2.jpg'),"title":"MES的构成"},
    {"imageUrl":require('../assets/solution/s1-3.jpg'),"title":"事例①：MES　 POINT OF PRODUCTION"},
    {"imageUrl":require('../assets/solution/s1-4.jpg'),"title":"事例②：MES系统开发和运用"}
    ],
    infos_ja: [
        {"imageUrl":require('../assets/solution/s1-0.jpg')},
        {"imageUrl":require('../assets/solution/s1-5.jpg'),"title":"MESは何？"},
        {"imageUrl":require('../assets/solution/s1-1-ja.jpg'),"title":"なぜMESが必要"},
        {"imageUrl":require('../assets/solution/s1-2-ja.jpg'),"title":"MESの機能構成"},
        {"imageUrl":require('../assets/solution/s1-3-ja.jpg'),"title":"事例①：MES　 POINT OF PRODUCTION"},
        {"imageUrl":require('../assets/solution/s1-4-ja.jpg'),"title":"事例②：MESシステム開発・運用"}
    ]
  })
};
</script>
